import { render, staticRenderFns } from "./BlogFeaturedPost.vue?vue&type=template&id=62a90273"
import script from "./BlogFeaturedPost.vue?vue&type=script&lang=js"
export * from "./BlogFeaturedPost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlogAuthorSign: require('/home/forge/ab.farescraper.com/components/BlogAuthorSign.vue').default})
